import * as React from "react"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"
import { CrossIcon } from "../../atoms/icons/CrossIcon"
import { motion } from "framer-motion"
import Backdrop from "../../atoms/Backdrop"

interface ModalProps {
  children: React.ReactNode
  onClose: () => void
  open: boolean
  closeIcon?: boolean
  backdropColor?: string
}

const CrossIconSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  position: absolute;
  top: 54px;
  right: 54px;
  z-index: 3;
`

const CrossIconButton = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    filter: brightness(40%);
  }
`

const ModalStyle = styled(motion.div)<{ fixedWidth?: boolean }>`
  max-height: 90vh;
  overflow-y: auto;

  ${MediaQuery.MD} {
    ${({ fixedWidth }) => fixedWidth && "width: 70%;"}
  }
  ${MediaQuery.XS} {
    ${({ fixedWidth }) => fixedWidth && "width: 85%;"}
    padding: ${(props) => props.theme.spacings.large};
  }
`

const dropIn = {
  hidden: {
    y: "-100%",
    opacity: 0,
  },
  visible: { y: 0, opacity: 1 },
  exit: {
    y: "100%",
    opacity: 0,
  },
}

const ModalWithoutCard: React.FunctionComponent<ModalProps> = ({
  children,
  onClose,
  open,
  closeIcon,
  backdropColor,
}) => {
  return (
    <>
      <Backdrop onClick={onClose} backdropcolor={backdropColor ?? "#000000e1"}>
        <ModalStyle
          onClick={(e) => e.stopPropagation()}
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <div>
            {closeIcon && (
              <CrossIconSection id="close">
                <CrossIconButton onClick={onClose}>
                  <CrossIcon />
                </CrossIconButton>
              </CrossIconSection>
            )}
            {children}
          </div>
        </ModalStyle>
      </Backdrop>
    </>
  )
}

export default ModalWithoutCard
